/**
 * Combine all reducers in this file and export the combined reducers.
 */
import { combineReducers } from 'redux';
import { sessionExtension } from './components/common/SessionModal/reducers';
import addons from './pages/Addons/reducer';
import contactInfo from './pages/ContactInfo/reducer';
import plansReferenceData from './utils/plansReference/reducer';
import cartDetails from './services/Cart/reducer';
import creditCheckDetails from './pages/CreditCheck/reducer';
import edgeIneligible from './pages/CreditcheckEdgeIneligible/reducer';
import registrationInfo from './pages/Registration/reducer';
import { progressSteps, processSteps } from './utils/ProgressStep/reducer';
import { progressStepsMV, processStepsMV } from './utils/ProgressStepMV/reducer';
import loaderReducer from './components/common/Loader/reducer';
import { notification } from './components/common/NotificationBar/reducer';
import deviceSetup from './pages/DeviceSetup/reducer';
import shippingInfo from './pages/ShippingInfo/reducer';
import cradleReducer from './pages/CradleService/reducer';
import termsAndConditions from './pages/ReviewOrderPage/reducer';
import appointmentSchedule from './pages/AppointmentSchedule/reducer';
import resumecartTemplate from './pages/ResumeCart/reducer';
import paymentInfo from './pages/PaymentInfo/reducer';
import orderConfirmation from './pages/OrderConfirmation/reducer';
import d2dEidQA from './pages/EidQuestions/reducer';
import creditDownPayment from './pages/CreditDownPayment/reducer';
import cBandPlans from './pages/CBandPlans/reducer';
import videoChat from './components/common/VideoChat/reducer';
import SessionValues from './pages/Common/SessionValues/reducer';
import tagging from './pages/Common/Tagging.js/reducer';
import techCBand from './pages/Tech/reducer';
import eagleCPC from './pages/CPC/reducer';
import whwTech from './pages/whwTech/reducer';
import moversReducer from './pages/Movers/@Redux/Reducer/MoversReducer';
import getCheckOutDetails from './pages/FuncComp/reducer';
import expressCartReducer from './pages/ExpressCart/reducer';
import Redirection from './pages/Redirection/reducer';
import verizonForward from './pages/VerizonForward/reducer';
import expressTermsAndConditions from './pages/TermandCondition/reducer';
import qualificationCheckDetails from './pages/WestWorldMigrate/reducer';
import deviceUpgradeDetails from './pages/DeviceUpgrade/reducer';
import popularPlansReducer from './pages/PopularPlans/@Redux/Reducer/popularPlans.reducer';
import progressivePlansReducer from './pages/ProgressivePlans/@Redux/Reducer/progressivePlans.reducer';
import progressivePlansRedesignReducer from './pages/ProgressivePlans/@Redux/DiscountToggleBar/reducer';
import showDeviceLockedModalReducer from './components/Web/Cart/MultipleSessionsModal/reducer';
import nbsReducer from './components/NextGen/NBS/@Redux/nbsReducer';
import ipiReducer from './components/NextGen/ImportantPlanInfo/@Redux/ipiReducer';
import checkoutReducer from './components/NextGen/ExpressCheckout/@Redux/checkoutReducer';
import orderWriteReducer from './components/NextGen/TermandCondition/@Redux/orderWriteReducer';
import createProfileReducer from './components/NextGen/CreateProfile/@Redux/createProfileReducer';
import perksAndServices from './components/NextGen/PerksAndServices/@Redux/perksAndServicesReducer';
import { notificationReducer as flowRedesignNotification } from './components/NextGen/FlowRedesignCommon/Notification/@Redux/reducer';

import creditStatus from './pages/CreditStatus/reducer';
import cpcVPMInspicio from './pages/plansandFeature/reducer';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
const allReducers = {
  plansReferenceData,
  processSteps,
  progressSteps,
  sessionExtension,
  addons,
  cartDetails,
  contactInfo,
  creditCheckDetails,
  creditStatus,
  registrationInfo,
  loader: loaderReducer,
  notification,
  deviceSetup,
  shippingInfo,
  termsAndConditions,
  appointmentSchedule,
  resumecartTemplate,
  paymentInfo,
  orderConfirmation,
  d2dEidQA,
  edgeIneligible,
  creditDownPayment,
  cBandPlans,
  videoChat,
  tagging,
  SessionValues,
  techCBand,
  eagleCPC,
  whwTech,
  processStepsMV,
  progressStepsMV,
  moversReducer,
  checkout: getCheckOutDetails,
  baseTemplate: expressCartReducer,
  Redirection,
  cradleReducer,
  verizonForward,
  qualificationCheckDetails,
  deviceUpgradeDetails,
  popularPlans: popularPlansReducer,
  progressivePlans: progressivePlansReducer,
  progressivePlansRedesign: progressivePlansRedesignReducer,
  showDeviceLockedModal: showDeviceLockedModalReducer,
  nextBillSummary: nbsReducer,
  importantInfo: ipiReducer,
  checkoutNew: checkoutReducer,
  expressTermsAndConditions,
  orderWriteReducer,
  createProfile: createProfileReducer,
  perksAndServices,
  cpcVPMInspicio,
  flowRedesignNotification,
};
export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    currentView,
    ...allReducers,
    ...injectedReducers,
  });
  return rootReducer;
}
const currentView = (state = {}, action) => {
  switch (action?.type) {
    case 'UPDATE_CURRENT_VIEW': {
      return { ...action.response };
    }
    case 'UPDATE_CURRENT_VIEW_MV': {
      return { ...action.response };
    }
    default:
      return state;
  }
};
